// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PAGE */
.product-page {
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
  --tw-bg-opacity: 1;
  min-height: 100vh;
  padding: 30px 0 60px;
  color: #1f2937;
  margin-top: 80px;
}

/* CONTAINER */
.product-page > * {
  max-width: 1200px;
  margin: auto;
  padding: 0 24px;
}

/* BREADCRUMB */
.breadcrumb {
  display: flex;
  /* gap: 10px; */
  list-style: none;
  color: #6b7280;
  margin-bottom: 24px;
}

.breadcrumb li {
  display: flex;
  align-items: center;
}




.breadcrumb a {
  color: #034EA2;
  text-decoration: none;
  font-weight: 600;
}

.breadcrumb .active {
  color: #111827;
  font-weight: 600;
}

/* ================= PRODUCT TOP ================= */

.product-top {
  display: flex;
  gap: 40px;
  align-items: flex-start;
  margin-bottom: 50px;
}

/* IMAGE */
.product-image {
  flex: 0 0 380px;
  position: relative;
}

.product-image img {
  width: 100%;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
}

.package-tag {
  position: absolute;
  bottom: 12px;
  left: 12px;
  background: #0f172a;
  color: #fff;
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 6px;
}

/* INFO */
.product-info {
  flex: 1 1;
}

.product-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-title h1 {
  font-size: 28px;
  font-weight: 700;
  margin: 0;
}

.status.active {
  background: #dcfce7;
  color: #166534;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 600;
}

/* DESCRIPTION */
.description {
  margin: 16px 0;
  color: #475569;
  font-size: 15px;
}

/* FEATURES */
.features ul {
  padding-left: 18px;
  margin: 0 0 24px;
}

.features li {
  margin-bottom: 8px;
  font-size: 14px;
  color: #334155;
}

/* CTA */
.cta {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 22px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}

.btn.primary {
  background: #034EA2;
  color: #fff;
  border: none;
}

.btn.outline {
  background: #fff;
  border: 1px solid #cbd5f5;
  color: #1e3a8a;
}

/* ================= MOBILE RESPONSIVE ================= */

@media (max-width: 768px) {
  .product-top {
    flex-direction: column;
    gap: 24px;
  }

  .product-image {
    flex: 100% 1;
    max-width: 100%;
  }

  .product-info {
    width: 100%;
  }

  .product-title {
    flex-wrap: wrap;
  }

  .product-title h1 {
    font-size: 22px;
  }

  .cta {
    flex-direction: column;
  }

  .cta .btn {
    width: 100%;
    text-align: center;
  }
}
/* ================= PRODUCT DETAIL PAGE ================= */

.status {
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 999px;
  font-weight: 500;
}

.status.active {
  background: #dcfce7;
  color: #15803d;
}

.description {
  margin: 12px 0 24px;
  color: #4b5563;
  font-size: 15px;
  line-height: 1.6;
}

/* FEATURES */
.features ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 30px;
  list-style: none;
  padding: 0;
  margin-bottom: 28px;
}

.features li {
  position: relative;
  padding-left: 20px;
  font-size: 18px;
}

.features li::before {
  content: "●";
  color: #034EA2;
  position: absolute;
  left: 0;
  top: 0;
}

/* CTA BUTTONS */
.cta {
  display: flex;
  gap: 14px;
}

.btn {
  padding: 12px 28px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
}

.btn.primary {
  background: #034EA2;
  color: #ffffff;
  box-shadow: 0 6px 18px rgba(3, 78, 162, 0.25);
}

.btn.outline {
  background: #ffffff;
  border: 1px solid #d1d5db;
  color: #374151;
}

/* SECTION BLOCKS */
.section {
  margin-top: 48px;
}

.section h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 18px;
}

/*Applications mobile*/
@media (max-width: 768px) {
  .section .applications {
    grid-template-columns: 1fr;
  }
}

/* TABLE */
.param-table {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  border-collapse: collapse;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
}

.param-table th {
  background: #f9fafb;
  padding: 14px 18px;
  font-size: 13px;
  color: #6b7280;
  text-transform: uppercase;
}

.param-table td {
  padding: 14px 18px;
  font-size: 14px;
  border-top: 1px solid #eef2f7;
}

tbody tr:hover {
  background: rgba(253, 185, 19, 0.18);
}

/* PACKAGE CARD */
.package-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr 180px;
  gap: 20px;
  align-items: center;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
}

.package-card img {
  width: 100%;
  border-radius: 8px;
}

/* APPLICATIONS */
.applications {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.app-card {
  background: #ffffff;
  padding: 22px;
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
  font-size: 16px;
  font-weight: 500;
  text-align: left;
}

/* LOADING */
.loading {
  text-align: center;
  margin: 60px;
  font-size: 16px;
  color: #6b7280;
}


body {
  background: #f7f9fc;
  font-family: "Ysabeau Office", sans-serif;
  color: #0f172a;
}

.product-wrapper {
  max-width: 1200px;
  margin: auto;
  padding: 30px 20px;
}

/* Tabs */
.tabs {
  display: flex;
  gap: 30px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 30px;
}

.tab {
  background: none;
  border: none;
  padding: 12px 0;
  font-size: 14px;
  color: #64748b;
  cursor: pointer;
  position: relative;
  display: inline-block;
  text-decoration: none;
}

.tab.active {
  color: #034EA2;
  font-weight: 600;
}

.tab.active::after {
  content: "";
  height: 2px;
  background: #034EA2;
  width: 100%;
  position: absolute;
  bottom: -1px;
  left: 0;
}

/* Section titles */
.section-title {
  font-size: 22px;
  font-weight: 600;
  margin: 30px 0 10px;
  color: black;
}

.section-sub {
  color: #64748b;
  font-size: 14px;
  margin-bottom: 20px;
}

/* Table */
.table-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.05);
  overflow: hidden;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-family: Poppins_Light, system-ui, sans-serif;
}

thead {
  background: #034EA2;
}

th {
  text-align: center;
  padding: 12px 18px;
  font-size: 11px;
  color: #ffffff;
  font-family: Poppins_Medium, system-ui, sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

td {
  padding: 12px 18px;
  font-size: 14px;
  border-top: 1px solid #eef2f7;
}

.bold {
  font-weight: 600;
}

.link {
  color: #034EA2;
  font-weight: 500;
}

/* Package */
.package-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr 260px;
  gap: 30px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.05);
}

.label {
  font-size: 12px;
  color: #64748b;
  margin-top: 10px;
}

.docs a {
  display: inline-block;
  margin-right: 20px;
  margin-top: 10px;
  font-size: 14px;
  color: #034EA2;
  text-decoration: none;
}

.order-box {
  background: #f8fafc;
  padding: 16px;
  border-radius: 10px;
  margin-top: 20px;
}

.order-row {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

.code {
  font-weight: 600;
}

.package-image img {
  width: 100%;
  border-radius: 12px;
}

/* Applications */
.applications {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 20px;
}

.app-card {
  background: #ffffff;
  padding: 24px;
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.05);
}

.app-card .icon {
  font-size: 26px;
  margin-bottom: 10px;
  display: inline-block;
  color: #034EA2;
}

.app-card h4 {
  font-size: 16px;
  margin-bottom: 8px;
  font-weight: 700;
}

.app-card p {
  font-size: 14px;
  color: #64748b;
}


/* ================= PACKAGE SECTION ================= */

.package-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  border: 1px solid #e6edf5;
  border-radius: 12px;
  overflow: hidden;
  padding: 0;
  margin-top: 24px;
}

.package-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #fff;
  padding: 16px 20px;
}

.package-row {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 32px;
}

.label {
  font-size: 12px;
  /* color: #8a94a6; */
  letter-spacing: 0.04em;
  font-weight: 800;
}

.package-info h4 {
  margin-top: 6px;
  font-size: 18px;
  font-weight: 600;
  color: #0b1f33;
}

.desc {
  margin-top: 6px;
  font-size: 15px;
  color: #0b1f33;
}

/* DOCUMENT LINKS */
.documents {
  margin-top: 8px;
}

.doc-links {
  margin-top: 8px;
  display: flex;
  gap: 18px;
}

.doc-link {
  font-size: 14px;
  color: #034EA2;
  text-decoration: none;
}

.doc-link:hover {
  text-decoration: underline;
}

/* ORDERING BOX */
.ordering-box {
  margin-top: 10px;
  background: #f8fbff;
  border: 1px solid #e6edf5;
  border-radius: 10px;
  padding: 16px;
}

.ordering-row {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

/* IMAGE */
.package-image {
  display: flex;
  justify-content: center;
  align-items: stretch;
  background: #ffffff;
  border-left: 1px solid #e6edf5;
}

.package-image img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

/* KEY STATS */
.key-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin: 20px 0 28px;
}

.stat-card {
  background: #f8fbff;
  border: 1px solid #c8d9f0;
  border-radius: 10px;
  padding: 16px 12px;
  text-align: center;
  font-family: Poppins_Light, system-ui, sans-serif;
}

.stat-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
  margin-bottom: 6px;
  line-height: 1.4;
}

.stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #034EA2;
  line-height: 1.2;
  font-family: Poppins_Medium, system-ui, sans-serif;
}

.stat-unit {
  font-size: 13px;
  color: #64748b;
  margin-top: 3px;
  font-weight: 500;
}

@media (max-width: 600px) {
  .key-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* RESPONSIVE */
@media (max-width: 900px) {
  .package-wrapper {
    grid-template-columns: 1fr;
  }
}


`, "",{"version":3,"sources":["webpack://./src/assets/styles/product.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,4DAA4D;EAC5D,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;;;;AAKA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,0DAA0D;;AAE1D;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,YAAU;IACV,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;AACA,4DAA4D;;AAE5D;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,UAAU;AACV;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;;AAGA,wDAAwD;;AAExD;EACE,aAAa;EACb,8BAA8B;EAC9B,MAAM;EACN,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* PAGE */\r\n.product-page {\r\n  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));\r\n  --tw-bg-opacity: 1;\r\n  min-height: 100vh;\r\n  padding: 30px 0 60px;\r\n  color: #1f2937;\r\n  margin-top: 80px;\r\n}\r\n\r\n/* CONTAINER */\r\n.product-page > * {\r\n  max-width: 1200px;\r\n  margin: auto;\r\n  padding: 0 24px;\r\n}\r\n\r\n/* BREADCRUMB */\r\n.breadcrumb {\r\n  display: flex;\r\n  /* gap: 10px; */\r\n  list-style: none;\r\n  color: #6b7280;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.breadcrumb li {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n\r\n\r\n\r\n.breadcrumb a {\r\n  color: #034EA2;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.breadcrumb .active {\r\n  color: #111827;\r\n  font-weight: 600;\r\n}\r\n\r\n/* ================= PRODUCT TOP ================= */\r\n\r\n.product-top {\r\n  display: flex;\r\n  gap: 40px;\r\n  align-items: flex-start;\r\n  margin-bottom: 50px;\r\n}\r\n\r\n/* IMAGE */\r\n.product-image {\r\n  flex: 0 0 380px;\r\n  position: relative;\r\n}\r\n\r\n.product-image img {\r\n  width: 100%;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.package-tag {\r\n  position: absolute;\r\n  bottom: 12px;\r\n  left: 12px;\r\n  background: #0f172a;\r\n  color: #fff;\r\n  padding: 6px 12px;\r\n  font-size: 12px;\r\n  border-radius: 6px;\r\n}\r\n\r\n/* INFO */\r\n.product-info {\r\n  flex: 1;\r\n}\r\n\r\n.product-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.product-title h1 {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  margin: 0;\r\n}\r\n\r\n.status.active {\r\n  background: #dcfce7;\r\n  color: #166534;\r\n  font-size: 12px;\r\n  padding: 4px 10px;\r\n  border-radius: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* DESCRIPTION */\r\n.description {\r\n  margin: 16px 0;\r\n  color: #475569;\r\n  font-size: 15px;\r\n}\r\n\r\n/* FEATURES */\r\n.features ul {\r\n  padding-left: 18px;\r\n  margin: 0 0 24px;\r\n}\r\n\r\n.features li {\r\n  margin-bottom: 8px;\r\n  font-size: 14px;\r\n  color: #334155;\r\n}\r\n\r\n/* CTA */\r\n.cta {\r\n  display: flex;\r\n  gap: 14px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.btn {\r\n  padding: 12px 22px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn.primary {\r\n  background: #034EA2;\r\n  color: #fff;\r\n  border: none;\r\n}\r\n\r\n.btn.outline {\r\n  background: #fff;\r\n  border: 1px solid #cbd5f5;\r\n  color: #1e3a8a;\r\n}\r\n\r\n/* ================= MOBILE RESPONSIVE ================= */\r\n\r\n@media (max-width: 768px) {\r\n  .product-top {\r\n    flex-direction: column;\r\n    gap: 24px;\r\n  }\r\n\r\n  .product-image {\r\n    flex: 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .product-info {\r\n    width: 100%;\r\n  }\r\n\r\n  .product-title {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .product-title h1 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .cta {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .cta .btn {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n}\r\n/* ================= PRODUCT DETAIL PAGE ================= */\r\n\r\n.status {\r\n  font-size: 12px;\r\n  padding: 6px 12px;\r\n  border-radius: 999px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status.active {\r\n  background: #dcfce7;\r\n  color: #15803d;\r\n}\r\n\r\n.description {\r\n  margin: 12px 0 24px;\r\n  color: #4b5563;\r\n  font-size: 15px;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* FEATURES */\r\n.features ul {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 10px 30px;\r\n  list-style: none;\r\n  padding: 0;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.features li {\r\n  position: relative;\r\n  padding-left: 20px;\r\n  font-size: 18px;\r\n}\r\n\r\n.features li::before {\r\n  content: \"●\";\r\n  color: #034EA2;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n/* CTA BUTTONS */\r\n.cta {\r\n  display: flex;\r\n  gap: 14px;\r\n}\r\n\r\n.btn {\r\n  padding: 12px 28px;\r\n  border-radius: 10px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  border: none;\r\n}\r\n\r\n.btn.primary {\r\n  background: #034EA2;\r\n  color: #ffffff;\r\n  box-shadow: 0 6px 18px rgba(3, 78, 162, 0.25);\r\n}\r\n\r\n.btn.outline {\r\n  background: #ffffff;\r\n  border: 1px solid #d1d5db;\r\n  color: #374151;\r\n}\r\n\r\n/* SECTION BLOCKS */\r\n.section {\r\n  margin-top: 48px;\r\n}\r\n\r\n.section h3 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n/*Applications mobile*/\r\n@media (max-width: 768px) {\r\n  .section .applications {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n/* TABLE */\r\n.param-table {\r\n  width: 100%;\r\n  background: #ffffff;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  border-collapse: collapse;\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.param-table th {\r\n  background: #f9fafb;\r\n  padding: 14px 18px;\r\n  font-size: 13px;\r\n  color: #6b7280;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.param-table td {\r\n  padding: 14px 18px;\r\n  font-size: 14px;\r\n  border-top: 1px solid #eef2f7;\r\n}\r\n\r\ntbody tr:hover {\r\n  background: rgba(253, 185, 19, 0.18);\r\n}\r\n\r\n/* PACKAGE CARD */\r\n.package-card {\r\n  background: #ffffff;\r\n  border-radius: 14px;\r\n  padding: 24px;\r\n  display: grid;\r\n  grid-template-columns: 1fr 180px;\r\n  gap: 20px;\r\n  align-items: center;\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.package-card img {\r\n  width: 100%;\r\n  border-radius: 8px;\r\n}\r\n\r\n/* APPLICATIONS */\r\n.applications {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 22px;\r\n}\r\n\r\n.app-card {\r\n  background: #ffffff;\r\n  padding: 22px;\r\n  border-radius: 14px;\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  text-align: left;\r\n}\r\n\r\n/* LOADING */\r\n.loading {\r\n  text-align: center;\r\n  margin: 60px;\r\n  font-size: 16px;\r\n  color: #6b7280;\r\n}\r\n\r\n\r\nbody {\r\n  background: #f7f9fc;\r\n  font-family: \"Ysabeau Office\", sans-serif;\r\n  color: #0f172a;\r\n}\r\n\r\n.product-wrapper {\r\n  max-width: 1200px;\r\n  margin: auto;\r\n  padding: 30px 20px;\r\n}\r\n\r\n/* Tabs */\r\n.tabs {\r\n  display: flex;\r\n  gap: 30px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.tab {\r\n  background: none;\r\n  border: none;\r\n  padding: 12px 0;\r\n  font-size: 14px;\r\n  color: #64748b;\r\n  cursor: pointer;\r\n  position: relative;\r\n  display: inline-block;\r\n  text-decoration: none;\r\n}\r\n\r\n.tab.active {\r\n  color: #034EA2;\r\n  font-weight: 600;\r\n}\r\n\r\n.tab.active::after {\r\n  content: \"\";\r\n  height: 2px;\r\n  background: #034EA2;\r\n  width: 100%;\r\n  position: absolute;\r\n  bottom: -1px;\r\n  left: 0;\r\n}\r\n\r\n/* Section titles */\r\n.section-title {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  margin: 30px 0 10px;\r\n  color: black;\r\n}\r\n\r\n.section-sub {\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Table */\r\n.table-card {\r\n  background: #ffffff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 8px 30px rgba(0,0,0,0.05);\r\n  overflow: hidden;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-family: Poppins_Light, system-ui, sans-serif;\r\n}\r\n\r\nthead {\r\n  background: #034EA2;\r\n}\r\n\r\nth {\r\n  text-align: center;\r\n  padding: 12px 18px;\r\n  font-size: 11px;\r\n  color: #ffffff;\r\n  font-family: Poppins_Medium, system-ui, sans-serif;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\ntd {\r\n  padding: 12px 18px;\r\n  font-size: 14px;\r\n  border-top: 1px solid #eef2f7;\r\n}\r\n\r\n.bold {\r\n  font-weight: 600;\r\n}\r\n\r\n.link {\r\n  color: #034EA2;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Package */\r\n.package-card {\r\n  background: #ffffff;\r\n  border-radius: 14px;\r\n  padding: 24px;\r\n  display: grid;\r\n  grid-template-columns: 1fr 260px;\r\n  gap: 30px;\r\n  box-shadow: 0 8px 30px rgba(0,0,0,0.05);\r\n}\r\n\r\n.label {\r\n  font-size: 12px;\r\n  color: #64748b;\r\n  margin-top: 10px;\r\n}\r\n\r\n.docs a {\r\n  display: inline-block;\r\n  margin-right: 20px;\r\n  margin-top: 10px;\r\n  font-size: 14px;\r\n  color: #034EA2;\r\n  text-decoration: none;\r\n}\r\n\r\n.order-box {\r\n  background: #f8fafc;\r\n  padding: 16px;\r\n  border-radius: 10px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.order-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 8px;\r\n}\r\n\r\n.code {\r\n  font-weight: 600;\r\n}\r\n\r\n.package-image img {\r\n  width: 100%;\r\n  border-radius: 12px;\r\n}\r\n\r\n/* Applications */\r\n.applications {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 24px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.app-card {\r\n  background: #ffffff;\r\n  padding: 24px;\r\n  border-radius: 14px;\r\n  box-shadow: 0 8px 30px rgba(0,0,0,0.05);\r\n}\r\n\r\n.app-card .icon {\r\n  font-size: 26px;\r\n  margin-bottom: 10px;\r\n  display: inline-block;\r\n  color: #034EA2;\r\n}\r\n\r\n.app-card h4 {\r\n  font-size: 16px;\r\n  margin-bottom: 8px;\r\n  font-weight: 700;\r\n}\r\n\r\n.app-card p {\r\n  font-size: 14px;\r\n  color: #64748b;\r\n}\r\n\r\n\r\n/* ================= PACKAGE SECTION ================= */\r\n\r\n.package-wrapper {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0;\r\n  border: 1px solid #e6edf5;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  margin-top: 24px;\r\n}\r\n\r\n.package-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  background: #fff;\r\n  padding: 16px 20px;\r\n}\r\n\r\n.package-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1.5fr;\r\n  gap: 32px;\r\n}\r\n\r\n.label {\r\n  font-size: 12px;\r\n  /* color: #8a94a6; */\r\n  letter-spacing: 0.04em;\r\n  font-weight: 800;\r\n}\r\n\r\n.package-info h4 {\r\n  margin-top: 6px;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #0b1f33;\r\n}\r\n\r\n.desc {\r\n  margin-top: 6px;\r\n  font-size: 15px;\r\n  color: #0b1f33;\r\n}\r\n\r\n/* DOCUMENT LINKS */\r\n.documents {\r\n  margin-top: 8px;\r\n}\r\n\r\n.doc-links {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  gap: 18px;\r\n}\r\n\r\n.doc-link {\r\n  font-size: 14px;\r\n  color: #034EA2;\r\n  text-decoration: none;\r\n}\r\n\r\n.doc-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* ORDERING BOX */\r\n.ordering-box {\r\n  margin-top: 10px;\r\n  background: #f8fbff;\r\n  border: 1px solid #e6edf5;\r\n  border-radius: 10px;\r\n  padding: 16px;\r\n}\r\n\r\n.ordering-row {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 14px;\r\n}\r\n\r\n/* IMAGE */\r\n.package-image {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: stretch;\r\n  background: #ffffff;\r\n  border-left: 1px solid #e6edf5;\r\n}\r\n\r\n.package-image img {\r\n  max-width: 100%;\r\n  height: auto;\r\n  object-fit: contain;\r\n}\r\n\r\n/* KEY STATS */\r\n.key-stats {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 14px;\r\n  margin: 20px 0 28px;\r\n}\r\n\r\n.stat-card {\r\n  background: #f8fbff;\r\n  border: 1px solid #c8d9f0;\r\n  border-radius: 10px;\r\n  padding: 16px 12px;\r\n  text-align: center;\r\n  font-family: Poppins_Light, system-ui, sans-serif;\r\n}\r\n\r\n.stat-label {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n  font-weight: 500;\r\n  margin-bottom: 6px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.stat-value {\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  color: #034EA2;\r\n  line-height: 1.2;\r\n  font-family: Poppins_Medium, system-ui, sans-serif;\r\n}\r\n\r\n.stat-unit {\r\n  font-size: 13px;\r\n  color: #64748b;\r\n  margin-top: 3px;\r\n  font-weight: 500;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .key-stats {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n/* RESPONSIVE */\r\n@media (max-width: 900px) {\r\n  .package-wrapper {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
